import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconStopShareScreen: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconStopShareScreen"><Path fillRule="evenodd" clipRule="evenodd" d="M22 20H2V4H22V20ZM12 10.9395L9.53027 8.46973L8.46973 9.53027L10.9395 12L8.46973 14.4697L9.53027 15.5303L12 13.0605L14.4697 15.5303L15.5303 14.4697L13.0605 12L15.5303 9.53027L14.4697 8.46973L12 10.9395Z" fill="currentColor"/></CentralIconBase>;
});

export default IconStopShareScreen;
